<section id="gb_sectionServiziList_section" class="gb_sectionServiziList">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center gb_smalltext">
        <span class="gb_h6">{{ "servizi" | translate }}</span>
      </div>
      <div class="col-12 gb_serviziList">
        <div class="gb_serviziContainer row justify-content-center align-items-center">
          <div class="gb_servizio col" [ngClass]="{'disabled': router.url.includes('/services-without-registration')}">
            <a routerLink="/{{authorityId}}/personal/dashboard" data-bg="1"
              [title]="'posizioni-debitorie' | translate" tabindex="0"
              attr.aria-label="{{ 'posizioni-debitorie' | translate }}">
              {{ "posizioni-debitorie" | translate }}
            </a>
          </div>
          <div class="gb_servizio col disabled d-none">
            <a routerLink="/{{authorityId}}/personal/dashboard" data-bg="2"
              [title]="'storico-operazioni' | translate"
              tabindex="0">
              {{ "storico-operazioni" | translate }}
            </a>
          </div>
          <div class="gb_servizio col">
            <ng-container *ngIf="{ isLogged: (authService.isLogged$ | async) } as vm">
              <ng-container *ngIf="vm.isLogged">
                <a [routerLink]="router.url.includes('/personal') ? ['/', authorityId, 'personal', 'search-debt-position'] : (router.url.includes('/services-without-registration') ? ['/', authorityId, 'services-without-registration'] : ['/', authorityId, 'personal', 'search-debt-position'])"
                  data-bg="3"
                  [title]="'ricerca-posizioni' | translate" tabindex="0"
                  attr.aria-label="{{ 'ricerca-posizioni' | translate }}">
                  {{ "ricerca-posizioni" | translate }}
                </a>
              </ng-container>
              <ng-container *ngIf="!vm.isLogged">
                <a [routerLink]="router.url.includes('/personal') ? ['/', authorityId, 'personal', 'search-debt-position'] : ['/', authorityId, 'services-without-registration', 'tabs', 'with']"
                  data-bg="3"
                  [title]="'pagamenti-con-avviso' | translate" tabindex="0"
                  attr.aria-label="{{ 'pagamenti-con-avviso' | translate }}">
                  {{ "pagamenti-con-avviso" | translate }}
                </a>
              </ng-container>
            </ng-container>
          </div>
          <div class="gb_servizio col">
            <a routerLink="/{{authorityId}}/support/archive" data-bg="4"
              [title]="'storico-assistenza-ticket' | translate" tabindex="0"
              attr.aria-label="{{ 'storico-assistenza-ticket' | translate }}">
              {{ "storico-assistenza-ticket" | translate }}
            </a>
          </div>
          <div class="gb_servizio col">
            <a routerLink="/{{authorityId}}/personal/search-payment-receipt" data-bg="5"
              [title]="'ricerca-ricevuta' | translate"
              tabindex="0"
              attr.aria-label="{{ 'ricerca-ricevuta' | translate }}">
              {{ "ricerca-ricevuta" | translate }}
            </a>
          </div>
          <div class="gb_servizio col">
            <ng-container *ngIf="{ isLogged: (authService.isLogged$ | async) } as vm">
              <ng-container *ngIf="vm.isLogged && institutionCategoriesService.categoriesService.getValue().categorieServizi.length > 0">
                <a [routerLink]="router.url.includes('/personal') ? ['/', authorityId, 'personal', 'spontaneous-payment'] : (router.url.includes('/services-without-registration') ? ['/', authorityId, 'services-without-registration','spontaneous-payment'] : ['/', authorityId, 'personal', 'spontaneous-payment'])"
                  data-bg="6"
                  [title]="'pagamento-spontaneo' | translate" tabindex="0"
                  attr.aria-label="{{ 'pagamento-spontaneo' | translate }}">
                  {{ "pagamento-spontaneo" | translate }}
                </a>
              </ng-container>
              <ng-container *ngIf="!vm.isLogged">
                <a [routerLink]="router.url.includes('/personal') ? ['/', authorityId, 'personal', 'spontaneous-payment'] : ['/', authorityId, 'services-without-registration', 'tabs', 'without']"
                  data-bg="6"
                  [title]="'pagamenti-senza-avviso' | translate" tabindex="0"
                  attr.aria-label="{{ 'pagamenti-senza-avviso' | translate }}">
                  {{ "pagamenti-senza-avviso" | translate }}
                </a>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
